import React, { useState } from "react";
import "../../../styles/trademodals.scss";
import { t } from "../../../../../utils/i18n";

const DisputeConfirmationModal = ({ onConfirm, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    setIsLoading(true);
    onConfirm();
  };
  return (
    <div
      className="modal-status-cont"
      tabIndex={-1}
      aria-hidden="true"
      id="disputeConfirmModal"
      aria-labelledby="disputeConfirmModalLabel"
    >
      <div className="modal-status-alert-cont">
        <div>
          <button
            type="button"
            className="close"
            onClick={() => {onClose('disputeConfirmModal')}}
            aria-label={t("p2p.common.close")}
            disabled={isLoading}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <br/>
        </div>
        <div>
          <p className="modal-title" id="disputeConfirmModalLabel">
            {t("p2p.dispute_confirm.title")}
          </p>
          <div className="trademodal-notice">
            <span>
              <b>{t("p2p.dispute_confirm.irreversible")}</b>{" "}
              {t("p2p.dispute_confirm.discussed")}
            </span>
          </div>
          <br/>
          {/* buttons */}
          <div className="modal-buttons-section">
            <div>
              <button
                type="button"
                className="modal-tradeaction-canceltradebtn"
                disabled={isLoading}
                onClick={() => {onClose('disputeConfirmModal')}}
              >
                {t("p2p.common.cancel")}
              </button>
            </div>
            <div>
              <button
                type="button"
                className="modal-tradeaction-paidbtn"
                data-dismiss="modal"
                onClick={(e) => handleClick(e)}
              >
                {isLoading ? t("p2p.common.please_wait") : t("p2p.common.confirm")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisputeConfirmationModal;
